/**
 * WAI-ARIA tabs keyboard model (https://www.w3.org/WAI/ARIA/apg/patterns/tabs/),
 * kept pure so PageTabs and Tabs share it and it is testable without a DOM.
 *
 * Horizontal tablist: ArrowRight / ArrowLeft move (wrapping), Home / End
 * jump to the first / last. Disabled tabs are skipped. Returns the index to
 * focus and select, or null when the key is not a tab-navigation key.
 */
export function nextTabIndex(
  key: string,
  current: number,
  disabled: readonly boolean[],
): number | null {
  const count = disabled.length;
  if (count === 0) return null;
  const enabled = (i: number) => !disabled[i];
  const step = (from: number, dir: 1 | -1): number => {
    for (let n = 1; n <= count; n += 1) {
      const i = (((from + dir * n) % count) + count) % count;
      if (enabled(i)) return i;
    }
    return from;
  };
  switch (key) {
    case 'ArrowRight':
      return step(current, 1);
    case 'ArrowLeft':
      return step(current, -1);
    case 'Home':
      return step(-1, 1);
    case 'End':
      return step(count, -1);
    default:
      return null;
  }
}
